import { render } from "./Classroom.vue?vue&type=template&id=650fe517&scoped=true"
import script from "./Classroom.vue?vue&type=script&lang=js"
export * from "./Classroom.vue?vue&type=script&lang=js"

import "./Classroom.vue?vue&type=style&index=0&id=650fe517&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-650fe517"]])

export default __exports__